export const createNewCheckoutRequest = (checkoutRequest) => {
    let { price } = checkoutRequest;
    let cancel_url = checkoutRequest.cancelUrl;
    let success_url = checkoutRequest.successUrl;
    let tolt_referral = checkoutRequest.toltReferral;
    let quantity = checkoutRequest.quantity;
    let promotion_code = checkoutRequest.promotionCode;
    let add_trial = checkoutRequest.addTrial;
    return {
        url: "/stripe/checkout",
        method: "POST",
        data: {
            price,
            cancel_url,
            success_url,
            tolt_referral,
            quantity,
            promotion_code,
            add_trial,
        },
    };
}

export const createCancelSubscriptionRequest = (subscription_id, reason_name, reason_description = "") => {
    return {
        url: "/stripe/cancel_subscription",
        method: "POST",
        data: {
            subscription_id,
            reason_name,
            reason_description,
        },
    };
}


export const createUpdateSubscriptionRequest = (
    stripe_subscription_id,
    new_price
  ) => {
    return {
      url: '/stripe/update_subscription',
      method: 'POST',
      data: {
        stripe_subscription_id,
        new_price,
      },
    };
};

export const createNewBillingPortalUrl = (subscription_id, success_url) => {
    return {
        url: "/stripe/billing_portal_url",
        method: "POST",
        data: {
            subscription_id,
            success_url,
        },
    };
}

export const createGetSubscriptionDetailsRequest = () => {
    return {
        url: "/stripe/subscription_details",
        method: "GET",
    };
}

export const createGetOrgInvoicesRequest = () => {
    return {
        url: "/stripe/invoices",
        method: "GET",
    };
}

export const createUpdateAccountCountRequest = (quantity) => {
    return {
        url: "/stripe/update_account_count",
        method: "POST",
        data: {
            quantity,
        },
    };
}
